<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    hide-selected
    hide-no-data
    no-filter
    multiple
    chips
    small-chips
    deletable-chips
    item-value="id"
    item-text="pessoa.nome"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-chip
          small
          v-if="item.item.codigoInterno"
          class="mr-2"
          label
        >
          {{ item.item.codigoInterno }}
        </v-chip>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.item.pessoa.nome }}
            <small>&nbsp;({{ item.item.pessoa.cnpj | cnpj }})</small>
          </v-list-item-title>
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import FornecedorService from '@/api/fornecedor-service';
import { hasAnyLetter, formatCnpj } from '@/utils/regex-utils';

const DEFAULT_LIMIT = 15;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Array,
    path: {
      type: String,
      default: 'fornecedor/score',
    },
    searchInCotacao: {
      type: Boolean,
      default: false,
    },
    searchInCompra: {
      type: Boolean,
      default: false,
    },
    searchInRequisicao: {
      type: Boolean,
      default: false,
    },
    searchByCodigoInterno: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Fornecedor',
    },
    cotacoes: Array,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    getCotacoes() {
      if (!this.cotacoes || !this.cotacoes.length) {
        return undefined;
      }
      return this.cotacoes.map(cot => cot.id).join(',');
    },
    buildFilter(val) {
      const text = val || '';
      const cnpjQuery = !hasAnyLetter(text) ? ` or cnpj like "${formatCnpj(text)}%"` : '';
      const filter = `nome like "%${text.toLowerCase()}%"${cnpjQuery}`;
      return `${filter} order by nome`;
    },
    searchFornecedores(val) {
      this.loading = true;

      FornecedorService.getFornecedores(this.path, {
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildFilter(val),
        codigoInterno: this.searchByCodigoInterno && val ? val.toLowerCase() : undefined,
        searchInCotacao: this.searchInCotacao ? this.searchInCotacao : undefined,
        searchInCompra: this.searchInCompra ? this.searchInCompra : undefined,
        searchInRequisicao: this.searchInRequisicao ? this.searchInRequisicao : undefined,
        cotacoes: this.getCotacoes(),
      })
        .then((response) => {
          this.items = response.data.content ? response.data.content : response.data;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchFornecedores, 1000);
  },
};
</script>
